import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { GetFactsReq, GetFactsRes } from '@/api/types/queries';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';
import { createFilterBody } from '@/helpers/createFilterParams';

function useFactsData({ docId, caseId, searchQuery, filters, page, pageSize }: GetFactsReq) {
  const { getFetchConfig } = useGetFetchConfig();
  const fetchConfigPOST = getFetchConfig({
    method: FetchMethod.POST,
    data: {
      searchQuery: searchQuery || '',
      page: page || 1,
      pageSize: pageSize || 50,
      paginated: true,
      ...createFilterBody(filters),
    },
  });

  return useQuery<GetFactsRes, Error>(
    [QueryEntity.CaseFacts, { caseId }, { docId, searchQuery, filters, page, pageSize }],
    async () => {
      const response = await fetch(`${APIBaseChronos}/api/case/${caseId}/facts/query`, {
        ...fetchConfigPOST,
      });
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    },
    { refetchOnWindowFocus: false },
  );
}

export default useFactsData;
